import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  clearCollectionComponentByIdMultilingual,
  getCollectionComponentByIdMultilingual,
} from '@wajeez-web/stores/content';
import { useNavigate } from 'react-router-dom';
import { useGetCollectionComponentByIdMultilingual } from '@wajeez-web/components/helpers';

import { CollectionComponentForm } from '../components/CollectionComponentForm';

export const EditCollectionComponentsCollectionComponentPage = () => {
  const { id } = useParams<{
    id: string;
  }>();

  const navigate = useNavigate();

  const collectionComponentDetailsMultilingual =
    useGetCollectionComponentByIdMultilingual();

  useEffect(() => {
    id && getCollectionComponentByIdMultilingual(id);

    return () => {
      clearCollectionComponentByIdMultilingual();
    };
  }, [id]);

  return (
    <div>
      <CollectionComponentForm
        type="Edit"
        onSubmit={() => {
          navigate(`/collection-components`);
        }}
        onCancel={() => {
          navigate(`/collection-components`);
        }}
        collectionComponentTypeId={
          collectionComponentDetailsMultilingual?.data?.typeId
        }
      />
    </div>
  );
};
